import { DEV_ONLY } from './../globalConstants';
import { ITagSearchItem } from './../types/hashtags.types'
import { findHashes } from 'common/utils/findHashes'
import { IMentionedPayload, IMentioned } from './../types/mentions.types'
import { getHashtagsFromHTML } from './getHashtagsFromHTML';

export interface IGetMentionsTagsParams {
  mentions: Map<string, IMentioned>
  mentionedClassIdentifier: string[]
  tags: Map<string, ITagSearchItem>
  html?: string
  inputElement?: HTMLDivElement
}

export const getMentionsTags = ({ mentions, mentionedClassIdentifier, tags, html, inputElement }: IGetMentionsTagsParams) => {
  try {
    const parsedEle = document.createElement('div')
    parsedEle.innerHTML = html

    const mentionsLists = [...mentionedClassIdentifier].map(identifier => {
      const eles = Array.from(parsedEle.querySelectorAll('a'))

      const taggedElements: Array<HTMLAnchorElement> = eles.filter(ele => ele?.href?.includes('/profile') || ele?.href?.includes('/company'))

      taggedElements.forEach((ele: any) => {
        ele.style = ''
        ele.classList.forEach(cName => ele.classList.remove(cName))
      })

      return taggedElements
    })

    const allMentions = []

    mentionsLists.forEach(nodeList => {
      allMentions.push(...nodeList)
    })

    const mentionedMap: Map<string, IMentionedPayload> = new Map()

    allMentions.map(ele => {
      const { id } = ele

      mentionedMap.set(id, {
        id,
        isMember: ele.href.includes('/profile')
      })
    })

    const mentioned: IMentionedPayload[] = []
    mentionedMap.forEach(val => mentioned.push(val))

    let tagged: string[] = []
    let correctHTML: string = html

    if (html && DEV_ONLY) {
      const hashTagInfo = getHashtagsFromHTML(html)

      tagged = hashTagInfo.tags
    }

    return {
      mentioned: mentioned || [],
      tagged: tagged,
      html: correctHTML
    } as const
  } catch (err) {
    console.error(err)
  }
}
